import { useCallback, useEffect, useState } from "react";
import {
  FAVORITES_EVENT,
  readFavorites,
  toggleFavoriteEntry,
  writeFavorites,
  type FavoriteItem,
  type ToggleResult,
} from "@/lib/favorites";

export function useFavorites() {
  const [items, setItems] = useState<FavoriteItem[]>([]);

  useEffect(() => {
    setItems(readFavorites());
    const sync = () => setItems(readFavorites());
    window.addEventListener(FAVORITES_EVENT, sync);
    window.addEventListener("storage", sync);
    return () => {
      window.removeEventListener(FAVORITES_EVENT, sync);
      window.removeEventListener("storage", sync);
    };
  }, []);

  const isFavorite = useCallback(
    (key: string) => items.some((entry) => entry.key === key),
    [items],
  );

  const toggle = useCallback(
    (item: Omit<FavoriteItem, "savedAt">): ToggleResult => toggleFavoriteEntry(item),
    [],
  );

  const remove = useCallback((key: string) => {
    writeFavorites(readFavorites().filter((entry) => entry.key !== key));
  }, []);

  const clear = useCallback(() => writeFavorites([]), []);

  return { items, isFavorite, toggle, remove, clear };
}